export const COMPOSER_SAVED_EVENT = "captureez:composer-saved";
export const notifyComposerSaved = (childId) => {
  if (childId && typeof window !== "undefined")
    window.dispatchEvent(
      new CustomEvent(COMPOSER_SAVED_EVENT, { detail: { childId } }),
    );
};
